"use client";

import { useState } from "react";

type Language = "curl" | "javascript" | "python";

interface CodeSampleProps {
  curl: string;
  javascript: string;
  python: string;
  title?: string;
}

const languageLabels: Record<Language, string> = {
  curl: "cURL",
  javascript: "JavaScript",
  python: "Python",
};

export function CodeSample({ curl, javascript, python, title }: CodeSampleProps) {
  const [activeTab, setActiveTab] = useState<Language>("curl");

  const codeMap: Record<Language, string> = {
    curl,
    javascript,
    python,
  };

  return (
    <div className="rounded-lg overflow-hidden shadow-lg">
      {title && (
        <div className="bg-neutral-700 px-4 py-2 text-neutral-300 text-sm font-medium">
          {title}
        </div>
      )}
      {/* Tabs */}
      <div className="flex bg-neutral-800 border-b border-neutral-700">
        {(Object.keys(languageLabels) as Language[]).map((lang) => (
          <button
            key={lang}
            onClick={() => setActiveTab(lang)}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              activeTab === lang
                ? "bg-neutral-700 text-white border-b-2 border-primary"
                : "text-neutral-400 hover:text-white hover:bg-neutral-700/50"
            }`}
          >
            {languageLabels[lang]}
          </button>
        ))}
      </div>
      {/* Code block */}
      <div className="bg-neutral-900 p-4 overflow-x-auto">
        <pre className="text-sm text-neutral-100 font-mono whitespace-pre-wrap break-words">
          <code>{codeMap[activeTab]}</code>
        </pre>
      </div>
    </div>
  );
}
